import React from 'react'
import { StyledFormElement as FormElement } from '../../common/FormElement'
// import Icon from 'common/components/Icon'
import Text from 'common/components/Text'
import Toolbar from '../../common/Toolbar'

const ActivityToolbar = ({ filter, setFilter, t }) => (
  <Toolbar top borderless>
    <FormElement underline={filter === 'all'}>
      <Text small medium light onClick={() => setFilter('all')}>
        {t('activity.filter.all')}
      </Text>
    </FormElement>
    <FormElement underline={filter === 'unread'}>
      <Text small medium light onClick={() => setFilter('unread')}>
        {t('activity.filter.unread')}
      </Text>
    </FormElement>

    <Toolbar.Spacer />

    {/* <FormElement>
      <Icon icon="more" />
    </FormElement> */}
  </Toolbar>
)

export default ActivityToolbar
